import React, { useState, useEffect } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, query, where, setDoc, doc, updateDoc, arrayUnion, getDocs } from 'firebase/firestore';
import { ShowText } from './ShowText.js';

export function ContactButton() {
    const [click, setclick] = useState(0)

    const [isDragging, setisDragging] = useState("false")
    const [mousecurrentPositionX, setX] = useState(0)
    const [mousecurrentPositionY, setY] = useState(0)
    const [touchcurrentPositionX, setX2] = useState(0)
    const [touchcurrentPositionY, setY2] = useState(0)

    //判断是不是foucus在textarea，如果是不能滑动（有bug）
    const [ifFoucs, setifFoucs] = useState(false)
    const focusTextarea = () => {
        setifFoucs(true)
    }

    const blurTextarea = () => {
        setifFoucs(false)
    }

    const mouseDown = (e) => {
        let contact = document.querySelector("#contact")
        let screenHeight = window.innerHeight
        setisDragging("true")
        setX(e.nativeEvent.offsetX);
        setY(e.nativeEvent.offsetY);
        if (e.touches) {
            const initialTouch = e.touches[0];
            let object = contact.getBoundingClientRect()
            let index = screenHeight * 0.3
            setX2(initialTouch.clientX - object.left + 10)
            setY2(initialTouch.clientY - object.top + index)
        }
    }
    const mouseMove = (e) => {
        if (!ifFoucs) {
            let contact = document.querySelector("#contact")
            if (mousecurrentPositionX !== 0 && mousecurrentPositionY !== 0 && isDragging === "true") {
                let currentPositionX = e.nativeEvent.clientX - mousecurrentPositionX;
                let currentPositionY = e.nativeEvent.clientY - mousecurrentPositionY;
                contact.style.top = currentPositionY + "px";
                contact.style.left = currentPositionX + "px";
            }
            if (touchcurrentPositionX !== 0 && touchcurrentPositionY !== 0 && isDragging === "true") {
                const initialTouch = e.touches[0];
                let currentPositionX = initialTouch.clientX - touchcurrentPositionX;
                let currentPositionY = initialTouch.clientY - touchcurrentPositionY;
                contact.style.transform = `translate(${currentPositionX}px, ${currentPositionY}px)`;
            }
        }
    }
    
    const mouseUp = () => {
        setisDragging("false")
    }
    const mouseLeave = () => {
        setisDragging("false")
    }

    const [ifshow, setifshow] = useState(false)
    const showContact = () => {
        let clickvalue = click
        setclick(clickvalue + 1)
        setifshow(true)
        document.querySelector("#contact").style.left = "10px"
        document.querySelector(".contact").style.left = "-5000px"
    }

    const hideContact = () => {
        setifshow(false)
        document.querySelector("#contact").style.left = "-5000px"
        document.querySelector(".contact").style.left = "-50px"
    }

    const [chatText, setchatText] = useState("")
    const handleInputChange = (e) => {
        let { value } = e.target
        setchatText(value)
    }

    let userID = localStorage.getItem("currentLoginUserID");
    const [chatExist, setchatExist] = useState("")
    const [click2, setclick2] = useState(0)
    useEffect(() => {
        if (ifshow) {
            getDocs(query(collection(cloudStore, "chatHistory"), where("userID", "==", userID)))
                .then((querySnapshot) => {
                    const chatExist = querySnapshot.docs.map((doc) => doc.data());
                    setchatExist(chatExist)
                });
        }
    });
// console.log(chatExist)
    const sendText = async () => {
        let clickvalue = click2
        setclick2(clickvalue + 1)
        let button = document.querySelector("#text");
        var newDiv = document.createElement("div");
        var text = "";
        newDiv.classList.add("tips");
        setTimeout(() => { newDiv.classList.add("disappear") }, 4500);

        let time = new Date()
        let day = time.getDate();
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let hours = time.getHours().toString().padStart(2, '0');
        let minutes = time.getMinutes().toString().padStart(2, '0');
        let seconds = time.getSeconds().toString().padStart(2, '0');
        let finalDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds

        let userID = localStorage.getItem("currentLoginUserID");
        let userName = localStorage.getItem("currentLoginUser")
        if (userName !== null && userID !== null) {
            setchatText("")

            if (chatExist.length > 0) {
                const docData = {
                    [finalDate]: {
                        userName: userName,
                        userID: userID,
                        showtime: finalDate,
                        realtime: time,
                        text: chatText,
                        chatName: userName
                    }
                }
                const docRef = doc(cloudStore, "chatHistory", userID);
                updateDoc(docRef, { Dialogue: arrayUnion(docData) });
            } else {
                const docData = {
                    "Dialogue": [{
                        [finalDate]: {
                            userName: userName,
                            userID: userID,
                            showtime: finalDate,
                            realtime: time,
                            text: chatText,
                            chatName: userName
                        }
                    }],
                    userID:userID
                }
                setDoc(doc(cloudStore, "chatHistory", userID), docData)
            }
        } else {
            text = document.createTextNode("请登录呦~");
            newDiv.appendChild(text);
            button.after(newDiv);
        }
    }

    const handleKeyDown1 = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            sendText();
        }
    };

    return (
        <div>
            <div
                className='button contact'
                onClick={showContact}
                style={{ fontFamily: "'ZCOOL XiaoWei', sans-serif" }}>联系客服</div>
            <div
                id='contact'
                onMouseDown={(e) => { mouseDown(e) }}
                onMouseMove={(e) => mouseMove(e)}
                onMouseUp={mouseUp}
                onMouseLeave={mouseLeave}
                onTouchStart={(e) => { mouseDown(e) }}
                onTouchMove={(e) => mouseMove(e)}
                onTouchEnd={mouseUp}
                onTouchCancel={mouseLeave}
            >
                <span
                    className="material-symbols-outlined"
                    onClick={hideContact}
                    style={{ cursor: "pointer", position: "sticky", marginTop: "10px", marginBottom: "15px" }}>
                    Close
                </span>
                <div className='forContact'>
                    <div onMouseDown={focusTextarea}
                        onMouseMove={focusTextarea}
                        onMouseUp={blurTextarea}
                        onMouseLeave={blurTextarea}>
                        <ShowText chatExist={chatExist} />
                    </div>
                    <form>
                        <label htmlFor="text"></label>
                        <textarea
                            id="text"
                            type="text"
                            placeholder="你想问什么呀？"
                            onChange={(e) => { handleInputChange(e) }}
                            onKeyDown={(e) => handleKeyDown1(e)}
                            value={chatText}
                            onFocus={focusTextarea}
                            onBlur={blurTextarea}
                        ></textarea>
                    </form>
                </div>
            </div>
        </div >
    );
}